module.exports = __webpack_public_path__ + "img/6.f0f6d28b.png";